import { render, staticRenderFns } from "./HistoryItemTypeCreate.vue?vue&type=template&id=5134b88c&scoped=true&"
import script from "./HistoryItemTypeCreate.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypeCreate.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypeCreate.vue?vue&type=style&index=0&id=5134b88c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5134b88c",
  null
  
)

export default component.exports